import { toast } from 'gcs-common/design-system/hooks/use-toast';
import { defaultAllowedFileTypes } from 'gcs-common/slices/tickets/ticketsConstants';
import type { Path, PathValue, UseFormReturn } from 'react-hook-form';

export const useAttachmentsInput = <T extends { attachments?: File[] }>(
  form: UseFormReturn<T>,
  allowedFileTypes: string[] = defaultAllowedFileTypes,
) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const newFiles = Array.from(event.target.files);
      const filteredFiles = newFiles.filter((file) => allowedFileTypes.includes(file.type));

      if (filteredFiles.length !== newFiles.length) {
        toast({
          description: 'Bitte nur Bilder auswählen.',
          duration: 5000,
          variant: 'destructive',
        });
      }

      const currentFiles = (form.getValues('attachments' as Path<T>) || []) as File[];
      form.setValue('attachments' as Path<T>, [...currentFiles, ...filteredFiles] as unknown as PathValue<T, Path<T>>, {
        shouldValidate: true,
      });
      event.target.value = '';
    }
  };

  return { handleFileChange };
};
